import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, useTheme, Button, useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";

const FamilyList = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const colors = tokens(theme.palette.mode);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();
  const [familyList, setFamilyList] = useState([]);

  useEffect(() => {
    const fetchFamilies = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/get_families`);
        console.log(response.data);
        setFamilyList(response.data["familyList"]);
        console.log(familyList);
      } catch (error) {
        console.error("Failed to fetch families:", error);
        toast.error("Failed to fetch families");
      }
    };

    fetchFamilies();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const columns = [
    // { field: "discipline_id", 
    //   headerName: "ID",
    // },
    {
      field: "family_id",
      headerName: "Family ID",
      flex: 1,
      minWidth: 140,
      cellClassName: "name-column--cell",
    },
    {
        field: "family_owner_membershipId",
        headerName: "Family Owner Membership ID",
        flex: 1,
      minWidth: 210,
        cellClassName: "name-column--cell",
    },
    {
        field: "family_owner_name",
        headerName: "Family Owner Name",
        flex: 1,
      minWidth: 190,
        cellClassName: "name-column--cell",
    },
    {
        field: "family_members_count",
        headerName: "Family Members Count",
        flex: 1,
      minWidth: 190,
        cellClassName: "name-column--cell",
    },
    {
        field: "family_members_names",
        headerName: "Family Members Names",
        flex: 1,
      minWidth: 260,
        cellClassName: "name-column--cell",
    }
  ];

  const handleSelectionChange = (newSelection) => {
    setSelectedRow(newSelection.length === 1 ? newSelection[0] : null);
    console.log(selectedRow);
  };

  const handleUpdate = () => {
    if (selectedRow) {
      console.log("Selected Row ", selectedRow);
      const selectFamily = familyList.find((family) => family.family_id === selectedRow);
      console.log(selectFamily);
      navigate("/manage_family", { state: { family: selectFamily } });
    }
  }

  const handleDelete = async () => {
    if (selectedRow) {
      console.log("Selected Row ", selectedRow);
      const selectFamily = familyList.find((family) => family.family_id === selectedRow);
      console.log(selectFamily);
      try {
        await axios.delete(`${config.apiBaseUrl}/delete_discipline/${selectedRow}`, {
          headers: {
            Authorization: `Bearer ${document.cookie
              .split("; ")
              .find((row) => row.startsWith("teba_auth_token="))
              ?.split("=")[1]}`,
          },
        });
        toast.success("Family deleted successfully");
        setFamilyList(familyList.filter((family) => family.family_id !== selectedRow));
        setSelectedRow(null);
      } catch (error) {
        console.error("Failed to delete family:", error);
        toast.error("Failed to delete family");
      }
    }
  }

  return (
    <Box m={{ xs: "12px", sm: "16px", md: "20px" }}>
      <ToastContainer />
      <Header title="Families" subtitle="Family List" />
      {selectedRow && (
        <Box display="flex" justifyContent="flex-start" flexWrap="wrap" gap={1} mt={2}>
          <Button variant="contained" color="success" sx={{ mr: { xs: 0, sm: "10px" } }} onClick={handleUpdate} size={isMobile ? "small" : "medium"}>
            Update
          </Button>
          <Button variant="contained" color="error" sx={{ mr: { xs: 0, sm: "10px" } }} onClick={handleDelete} size={isMobile ? "small" : "medium"}>
            Delete
          </Button>
          {/* <Button variant="contained" color="secondary">
            Add
          </Button> */}
        </Box>
      )}
      <Box
        mt={{ xs: 2, sm: 2.5, md: 4 }}
        height={{ xs: "62vh", sm: "68vh", md: "75vh" }}
        minHeight={{ xs: 360, sm: 420, md: 480 }}
        sx={{
          overflowX: "auto",
          "& .MuiDataGrid-root": {
            border: "none",
            minWidth: 1020,
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
            fontSize: { xs: "0.76rem", sm: "0.82rem", md: "0.875rem" },
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: { xs: "0.72rem", sm: "0.8rem", md: "0.875rem" },
            fontWeight: 700,
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid 
          checkboxSelection 
          rows={Array.isArray(familyList) ? familyList : []}
          columns={columns} 
          rowHeight={isMobile ? 46 : 52}
          getRowId={(row) => row.family_id}
          onRowSelectionModelChange={handleSelectionChange}/>
      </Box>
    </Box>
  );
};

export default FamilyList;